import Marquee from "react-fast-marquee";

const items = [
    { dot: "bg-emerald-400", text: "One source of truth across every department" },
    { dot: "bg-cyan-300", text: "Revenue, people, projects and finance in sync" },
    { dot: "bg-amber-glow", text: "Business bottlenecks surfaced before they slow growth" },
    { dot: "bg-violet-300", text: "AI transforming operational data into decisions" },
    { dot: "bg-emerald-400", text: "Forecasts updated automatically from live signals" },
    { dot: "bg-cyan-300", text: "Company-wide visibility without constant follow-ups" },
    { dot: "bg-amber-glow", text: "Every team aligned. Every metric connected." },
  ];

export const StatusTicker = () => (
    <div
        className="relative z-40 border-b border-white/[0.06] bg-black/40 backdrop-blur-sm"
        data-testid="status-ticker"
    >
        <div className="max-w-7xl mx-auto px-6 sm:px-8">
            <div className="flex items-center gap-4 py-2 font-code text-[10.5px] text-zinc-500">
                <span className="hidden sm:inline-flex items-center gap-1.5 shrink-0 text-emerald-400">
                    <span className="w-1.5 h-1.5 rounded-full bg-emerald-400 animate-pulse-glow" />
                    LIVE
                </span>
                <span className="ticker-mask flex-1 overflow-hidden">
                    <Marquee gradient={false} speed={30} pauseOnHover>
                        {items.concat(items).map((it, i) => (
                            <span
                                key={i}
                                className="flex items-center gap-2 mx-8 whitespace-nowrap"
                            >
                                <span className={`w-1 h-1 rounded-full ${it.dot}`} />
                                <span className="text-zinc-400">{it.text}</span>
                            </span>
                        ))}
                    </Marquee>
                </span>
            </div>
        </div>
    </div>
);
